import hostingBanner from '../assets/ads/hosting-banner.jpg';
import seoBanner from '../assets/ads/seo-banner.jpg';
import domainSidebar from '../assets/ads/domain-sidebar.jpg';
import cloudSidebar from '../assets/ads/cloud-sidebar.jpg';
import websiteBuilder from '../assets/ads/website-builder.jpg';
import emailMarketing from '../assets/ads/email-marketing.jpg';
import cybersecurity from '../assets/ads/cybersecurity.jpg';

/** @typedef {{ id: string, title: string, description: string, image: string, cta: string, url: string, sponsor: string, category: string }} StaticAd */

export const bannerAds = [
  {
    id: 'hosting-1',
    title: 'Ultra-Fast Hosting',
    description:
      '99.9% uptime guaranteed. Scale your website with enterprise-grade infrastructure.',
    image: hostingBanner,
    cta: 'Get Started',
    url: '#',
    sponsor: 'CloudHost Pro',
    category: 'Hosting',
  },
  {
    id: 'seo-1',
    title: 'Boost Your Rankings',
    description: 'AI-powered SEO analytics to dominate search results.',
    image: seoBanner,
    cta: 'Try Free',
    url: '#',
    sponsor: 'SEO Analytics Pro',
    category: 'Marketing',
  },
];

export const sidebarAds = [
  {
    id: 'domain-1',
    title: 'Get Your Domain',
    description: 'Premium domains starting at $2.99/yr. Find the perfect name.',
    image: domainSidebar,
    cta: 'Search Domains',
    url: '#',
    sponsor: 'DomainHub',
    category: 'Domains',
  },
  {
    id: 'cloud-1',
    title: 'Unlimited Cloud Storage',
    description: 'Secure, fast, and reliable cloud storage for teams.',
    image: cloudSidebar,
    cta: 'Start Free',
    url: '#',
    sponsor: 'CloudVault',
    category: 'Storage',
  },
];

export const carouselAds = [
  {
    id: 'builder-1',
    title: 'Build Stunning Websites',
    description: 'Drag-and-drop website builder with 500+ templates.',
    image: websiteBuilder,
    cta: 'Build Now',
    url: '#',
    sponsor: 'WebCraft',
    category: 'Tools',
  },
  {
    id: 'email-1',
    title: 'Email That Converts',
    description: 'Send beautiful campaigns that drive results.',
    image: emailMarketing,
    cta: 'Start Free Trial',
    url: '#',
    sponsor: 'MailForge',
    category: 'Marketing',
  },
  {
    id: 'security-1',
    title: 'Enterprise Security',
    description: 'Protect your business with next-gen cybersecurity.',
    image: cybersecurity,
    cta: 'Learn More',
    url: '#',
    sponsor: 'CyberShield',
    category: 'Security',
  },
];

export const cardAds = [
  {
    id: 'card-hosting',
    title: 'Premium Hosting',
    description:
      'Blazing fast servers with 24/7 support. Your site deserves the best infrastructure.',
    image: hostingBanner,
    cta: 'Get 50% Off',
    url: '#',
    sponsor: 'CloudHost Pro',
    category: 'Hosting',
  },
  {
    id: 'card-seo',
    title: 'SEO Powerhouse',
    description:
      'Track rankings, analyze competitors, and grow organic traffic effortlessly.',
    image: seoBanner,
    cta: 'Try Free',
    url: '#',
    sponsor: 'SEO Analytics Pro',
    category: 'Marketing',
  },
];

export function pickStaticAd({ position = 'sidebar', size = 'medium', slot = 0 }) {
  const i = typeof slot === 'number' && !Number.isNaN(slot) ? slot : 0;

  if (position === 'search') {
    return cardAds[i % cardAds.length] || null;
  }
  if (position === 'banner') {
    return bannerAds[i % bannerAds.length] || null;
  }
  if (position === 'inline') {
    return carouselAds[i % carouselAds.length] || null;
  }
  if (position === 'sidebar') {
    if (size === 'large') return sidebarAds[0] || null;
    return sidebarAds[1 % sidebarAds.length] || null;
  }
  return bannerAds[0] || null;
}
